export default __webpack_public_path__ + "static/media/resume.53828c53.png";